module.exports = __webpack_public_path__ + "media/images/gallery/constellations/cancer/cnc_names-83437cc87ea8bbb04af5a98964aa63b4.gif";